// We specify a prefix to avoid mixing featureFlags with other possible query params
const FEATURE_FLAGS_PREFIX = "flag_";
/**
 * This function will filter the URL query params that start with the _flag prefix
 *
 * example: "www.immonet.de/expose/xxx?flag_abtest-contact=B"
 * will return { 'abtest-contact': 'B' }
 */
const getFeaturesFlagsFromQuery = (query) => {
    const searchParams = new URLSearchParams(query);
    const result = {};
    searchParams.forEach((value, key) => {
        if (key.startsWith(FEATURE_FLAGS_PREFIX)) {
            result[key.replace(FEATURE_FLAGS_PREFIX, "")] = value;
        }
    });
    return result;
};
/**
 * This function will be executed at the Request time
 * The FeatureFlag object from BFF is merged/overrode with query params from the URL provided with the Prefix
 *
 * example: "www.immonet.de/expose/xxx?flag_abtest-contact=B" will assign the variant B to the experiment 'abtest-contact'*
 * @param query - query string from the URL
 * @param featuresFlags - featuresFlags from the BFF
 *
 * @returns the FeatureFlags object with the query params merged
 *
 */
export const getFeaturesFlags = (featuresFlags, query) => {
    if (!featuresFlags)
        return {};
    const featuresFlagsFromQuery = getFeaturesFlagsFromQuery(query);
    return { ...featuresFlags, ...featuresFlagsFromQuery };
};
